import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams, HttpErrorResponse } from "@angular/common/http";
import { ExchangeType, CacheService } from "mapfre-auditlib";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({
   providedIn: "root"
})
export class ExchangeTypeService {

   className = 'ExchangeTypeService'

   constructor(private http: HttpClient, private cacheService: CacheService) { }

   getAllExchanges(cache = true, cacheKey = "allExchanges"): Observable<ExchangeType[]> {
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
       } else {
         let observable = this.http.get<ExchangeType[]>(environment.base_URL + "/exchange-types").pipe(map((res) => {
         this.cacheService.updateCacheData(res, cacheKey)
         return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
       }
   }

   newExchange(exchange) {
      return this.http.post(environment.base_URL + "/exchange-types", exchange)
   }

   updateExchange(exchange, id) {
      return this.http.put(environment.base_URL + `/exchange-types/${id}`, exchange)
   }

   deleteExchange(id: Number) {
      return this.http.delete(environment.base_URL + `/exchange-types/${id}`)
   }

   importExchanges(exchanges: any[]) {
      return this.http.post(environment.base_URL + "/exchange-types/import", exchanges)
   }

}
